// extracted by mini-css-extract-plugin
export default {"root":"NotificationTemplate_root__s7rey","message":"NotificationTemplate_message__fztrz","close":"NotificationTemplate_close__Mzrdg"};